import React, { useEffect, useState } from 'react';
import Icon from "../../../assets/images/brush.png";
import IconImg1 from "../../../assets/images/we-do-icon-1.png";
import IconImg2 from "../../../assets/images/we-do-icon-2.png";
import IconImg3 from "../../../assets/images/we-do-icon-3.png";
import Slider from "react-slick";
import { axiosInstance, config } from '../config';
import { Link } from 'react-router-dom';

const carouselSetting = {
    dots: true,
    speed: 750,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    className: "center",
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2,
                centerMode: true,
                centerPadding: '30px',
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

const Service = () => {
    const [activeIndex, setActiveIndex] = useState(1);

    const [services,setServices] = useState([])
    const [Loading, setLoading] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0)
        getCustomersInfo();
    }, []);
    
    function getCustomersInfo() {
        setLoading(true);
        axiosInstance.get(`/services`)
            .then(res => {
                // Limit to the first 3 services
                const limitedServices = res?.data?.service;
    
                // Define your icons, you can replace these with the actual icon URLs or imported images
                const icons = [
                    IconImg1, // Replace with your actual icon or image import
                    IconImg2, 
                    IconImg3
                ];
    
                // Add Icons to the services
                const servicesWithIcons = limitedServices.map((service, index) => ({
                    ...service,
                    Icons: icons[index % icons.length]  // This will repeat the icons array
                }));
    
                setServices(servicesWithIcons);  // Set the modified services with icons
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false);
            });
    }

    const handleAfterChange = (current) => {
        if((services.length-1) == current){
            setActiveIndex(0);
        }else{
            setActiveIndex(current + 1);
        }
    };

    return (
        <div>
            <div className="rs-services services-style2 gray-bg pt-120 pb-120 md-pt-80 md-pb-90">
                <div className="container custom">
                    <div className="sec-title2 text-center mb-40">
                        <div className="brush-content center-text mb-20">
                            <img src={Icon} alt="" />
                            <span className="sub-text"> What We Do</span>
                        </div>
                        <h2 className="title">
                            Our Most Popular Cleaning <br />
                            Services For You
                        </h2>
                    </div>
                    <div className='row team-member'>
                        <Slider 
                            {...carouselSetting} 
                            afterChange={handleAfterChange}
                        >
                            {services.map((ser, i) => (
                                <div className="services-slider col-md-4 mb-3" key={i}>
                                    <div className={`services-item ${activeIndex === i ? "active" : ""}`}>
                                        <div className="services-img">
                                            <Link to={`${config.appUrl}service/${ser.slug}`}>
                                                <img src={ser.Icons} title={ser.title} alt="" />
                                            </Link>
                                        </div>
                                        <div className="services-content">
                                            <h3 className="title"><Link to={`${config.appUrl}service/${ser.slug}`}>{ser.name}</Link></h3>
                                            <p className="description">{ser.title}</p>
                                            <div className="services-btn">
                                                <Link to={`${config.appUrl}service/${ser.slug}`}>
                                                    <span className="btn-text">Read More</span>
                                                    <i className="bi bi-arrow-right-short"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Service;
